import { useRef } from "react";
import PageContainer from "@components/layout/PageContainer";
import { useNavigate } from "react-router-dom";
import ModelIndex, { ModelIndexHandle } from "@components/layout/ModelIndex";
import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { showAlert } from "@utils/Alert";
import { ShippingProviderApi, ShippingProviderDataType } from "@/api/ShippingProviderApi";

/**
 * A diferencia de Clientes o Productos, este listado va contra DynamoDB y no contra
 * Meilisearch: no hay indice para el modelo y el volumen (un punado de couriers por
 * suscripcion) no justifica crearlo.
 */
const ShippingProviderIndex = () => {
  const navigate = useNavigate();
  const modelRef = useRef<ModelIndexHandle>(null);

  const deleteRecord = async (id: string) => {
    const { errors } = await ShippingProviderApi.delete(id);
    if (errors?.length) {
      showAlert('danger', 'El Proveedor de Envio no pudo ser eliminado');
    } else {
      showAlert('success', 'El Proveedor de Envio fue eliminado correctamente');
    }
    modelRef.current?.refetch();
  }

  return (
    <PageContainer
      title="Proveedores de Envio"
      backUrl="/user/clients"
      primaryActions={[
        {
          onClick: () => {
            navigate('/user/shipping-provider')
          },
          actionTitle: "Nuevo",
          color: "success"
        }
      ]}
    >
      <ModelIndex<ShippingProviderDataType>
        ref={modelRef}
        fetchData={(filters, token, limit) => ShippingProviderApi.fetchAll(filters, token, limit)}
        filterProps={[
          {
            key: "codigo",
            filterType: "eq",
            type: "number"
          },
          {
            key: "nombre",
            filterType: "contains"
          }
        ]}
        primaryProperties={[
          {
            key: "codigo",
            highlighted: true
          },
          {
            key: "nombre",
            alignment: "Start"
          },
        ]}
        secondaryProperties={[
          {
            key: "identificacion",
            title: "Identificacion",
          },
          {
            key: "telefono",
            title: "Telefono",
          },
          {
            key: "email",
            title: "Email"
          }
        ]}
        secondaryPropertiesSizing={[
          { sm: "4", md: "4" },
          { sm: "3", md: "3" },
          { sm: "3", md: "3" },
        ]}
        listActions={[
          {
            href: "/user/shipping-provider/{:id}",
            actionTitle: "Editar Proveedor de Envio",
            iconProps: { icon: faEdit }
          },
          {
            actionTitle: "Eliminar Proveedor de Envio",
            iconProps: { icon: faTrash },
            needConfirm: true,
            confirmProps: {
              title: "Eliminar Proveedor de Envio",
              confirmMessage: "¿Seguro que desea eliminar este Proveedor de Envio?",
              confirmBtnText: "Eliminar"
            },
            onClick: (id: string) => { deleteRecord(id) }
          }
        ]}
      >
      </ModelIndex>

    </PageContainer >
  );
}

export default ShippingProviderIndex;
